import { AddressBookIcon } from "@phosphor-icons/react/AddressBook";
import { BankIcon } from "@phosphor-icons/react/Bank";
import { ClockCounterClockwiseIcon } from "@phosphor-icons/react/ClockCounterClockwise";
import { CreditCardIcon } from "@phosphor-icons/react/CreditCard";
import { GiftIcon } from "@phosphor-icons/react/Gift";
import { GlobeHemisphereWestIcon } from "@phosphor-icons/react/GlobeHemisphereWest";
import { NotePencilIcon } from "@phosphor-icons/react/NotePencil";
import { PackageIcon } from "@phosphor-icons/react/Package";
import { ReceiptIcon } from "@phosphor-icons/react/Receipt";
import { TagIcon } from "@phosphor-icons/react/Tag";
import { TruckIcon } from "@phosphor-icons/react/Truck";
import { UsersIcon } from "@phosphor-icons/react/Users";
import { WebhooksLogoIcon } from "@phosphor-icons/react/WebhooksLogo";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { MenuSeparator } from "@freightsimple/ui-core/Menu/Menu";

/** The dropdown item buttons for each group. Reused by the inline dropdown and
 *  by the "More" overflow menu — only ever one instance renders at a time, so
 *  the `subnav-*` testids don't duplicate. */
export function shipmentsItems(
  onNavigate: (path: string) => void,
  showDrafts: boolean,
) {
  return [
    <Button
      key="/"
      icon={TruckIcon}
      data-testid="subnav-Active Shipments"
      onClick={() => onNavigate("/")}
    >
      Active Shipments
    </Button>,
    <Button
      key="/quotes"
      icon={TagIcon}
      data-testid="subnav-Recent Quotes"
      onClick={() => onNavigate("/quotes")}
    >
      Recent Quotes
    </Button>,
    ...(showDrafts
      ? [
          <Button
            key="/drafts"
            icon={NotePencilIcon}
            data-testid="subnav-Draft Shipments"
            onClick={() => onNavigate("/drafts")}
          >
            Draft Shipments
          </Button>,
        ]
      : []),
    <Button
      key="/view-all-shipments"
      icon={ClockCounterClockwiseIcon}
      data-testid="subnav-Past Shipments"
      onClick={() => onNavigate("/view-all-shipments")}
    >
      Past Shipments
    </Button>,
  ];
}

export function manageCompanyItems(
  onNavigate: (path: string) => void,
  onReferralCode: () => void,
) {
  return [
    <Button
      key="/address-book"
      icon={AddressBookIcon}
      data-testid="subnav-Address Book"
      onClick={() => onNavigate("/address-book")}
    >
      Address Book
    </Button>,
    <Button
      key="/brokers"
      icon={GlobeHemisphereWestIcon}
      data-testid="subnav-Customs Brokers"
      onClick={() => onNavigate("/brokers")}
    >
      Customs Brokers
    </Button>,
    <Button
      key="/saved-commodities"
      icon={PackageIcon}
      data-testid="subnav-Saved Commodities"
      onClick={() => onNavigate("/saved-commodities")}
    >
      Saved Commodities
    </Button>,
    <Button
      key="/manage-users"
      icon={UsersIcon}
      data-testid="subnav-Manage Users"
      onClick={() => onNavigate("/manage-users")}
    >
      Manage Users
    </Button>,
    <Button
      key="referral"
      icon={GiftIcon}
      data-testid="subnav-Referral Code"
      onClick={onReferralCode}
    >
      Referral Code
    </Button>,
  ];
}

export function financialItems(onNavigate: (path: string) => void) {
  return [
    <Button
      key="/view-invoices"
      icon={ReceiptIcon}
      data-testid="subnav-Invoices"
      onClick={() => onNavigate("/view-invoices")}
    >
      Invoices
    </Button>,
    <MenuSeparator key="separator" />,
    <Button
      key="/credit-cards"
      icon={CreditCardIcon}
      data-testid="subnav-Credit Cards"
      onClick={() => onNavigate("/credit-cards")}
    >
      Credit Cards
    </Button>,
    <Button
      key="/bank-accounts"
      icon={BankIcon}
      data-testid="subnav-Bank Accounts"
      onClick={() => onNavigate("/bank-accounts")}
    >
      Bank Accounts
    </Button>,
  ];
}

export function developersItems(onNavigate: (path: string) => void) {
  return [
    <Button
      key="/webhook-deliveries"
      icon={WebhooksLogoIcon}
      data-testid="subnav-Webhook Deliveries"
      onClick={() => onNavigate("/webhook-deliveries")}
    >
      Webhook Deliveries
    </Button>,
  ];
}
